import { CREDIT_TYPES } from "common/model/creditType";
export type SelectedInstitutionType = {
  ID: string;
  countryName: string;
  displayName: string;
};

export class SelectedInstitution implements SelectedInstitutionType {
  ID: string;
  countryName: string;
  displayName: string;
  constructor({ ID, countryName, displayName }: SelectedInstitutionType) {
    this.ID = ID;
    this.countryName = countryName;
    this.displayName = displayName;
  }
}

export function isSelectedInstitution(
  object: unknown,
): object is SelectedInstitutionType {
  return (
    Object.prototype.hasOwnProperty.call(object, "ID") &&
    Object.prototype.hasOwnProperty.call(object, "countryName") &&
    Object.prototype.hasOwnProperty.call(object, "displayName")
  );
}

export type CreditBookmarkType = {
  creditItemID: string;
  creditType: CREDIT_TYPES;
  sourceInstitutionID: string;
  timestamp: number;
};

export class CreditBookmark implements CreditBookmarkType {
  creditItemID: string;
  creditType: CREDIT_TYPES;
  sourceInstitutionID: string;
  timestamp: number;
  constructor({
    creditItemID,
    creditType,
    sourceInstitutionID,
    timestamp,
  }: CreditBookmarkType) {
    this.creditItemID = creditItemID;
    this.creditType = creditType;
    this.sourceInstitutionID = sourceInstitutionID;
    this.timestamp = timestamp;
  }
}

export function isCreditBookmark(
  object: unknown,
): object is CreditBookmarkType {
  return (
    Object.prototype.hasOwnProperty.call(object, "creditItemID") &&
    Object.prototype.hasOwnProperty.call(object, "creditType") &&
    Object.prototype.hasOwnProperty.call(object, "sourceInstitutionID") &&
    Object.prototype.hasOwnProperty.call(object, "timestamp")
  );
}
